import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import createRootReducer from '../reducers';
import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();
const loggerMiddleware = createLogger();
const rootReducer = createRootReducer();

export default function configureAppStore(preloadedState) {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      thunk: false,
      // need this to supress warning with callback functions in action payload.
      serializableCheck: false,
    }).concat(sagaMiddleware, loggerMiddleware),
    preloadedState,
    devTools: process.env.NODE_ENV === 'development',
  });

  sagaMiddleware.run(rootSaga);
  return store;
}
